import axios, { AxiosRequestConfig } from 'axios';
import { apiBaseURL } from '@/settings/environment';
import {
  reformFaildResponse,
  reformRequest,
  reformResponse,
} from './transform';

const DEFAULT_API_CONFIG: AxiosRequestConfig = {
  baseURL: apiBaseURL(),
  timeout: 300000,
  withCredentials: true,
};

export const instance = axios.create({ ...DEFAULT_API_CONFIG });
instance.interceptors.request.use((res) => reformRequest(res));
instance.interceptors.response.use(
  (res) => reformResponse(res),
  (err) => reformFaildResponse(err),
);

export const api = {
  get: async (path: string, config?: AxiosRequestConfig): Promise<any> => {
    return await instance.get(path, config);
  },
  post: async (
    path: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<any> => {
    return await instance.post(path, data, config);
  },
  put: async (
    path: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<any> => {
    return await instance.put(path, data, config);
  },
  patch: async (
    path: string,
    data?: any,
    config?: AxiosRequestConfig,
  ): Promise<any> => {
    return await instance.patch(path, data, config);
  },
  delete: async (path: string, config?: AxiosRequestConfig): Promise<any> => {
    return await instance.delete(path, config);
  },
};
